import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@mui/styles";

import { ApikeysTable, Header } from "../../components";
import { styles } from "../../styles/global";
import { getRequestMetadata } from "../../api";
import { BodyContainer } from "../../components/BaseComponents";

function Apikeys(props) {
  const organizationId = getRequestMetadata().suki_organization_id;

  return (
    <>
      <Header headerTitle="API Keys Management" onDrawerToggle={props.onDrawerToggle} />
      <BodyContainer>
        <ApikeysTable organizationId={organizationId} />
      </BodyContainer>
    </>
  );
}

Apikeys.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(Apikeys);
